import { HStack, Icon, Text } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
export const Wrapper = HStack.withConfig({
  alignItems: 'center',
  marginBottom: '$1',
});

export const Message = Text.withConfig({
  marginLeft: '1.5',
  textTransform: 'capitalize',
  fontSize: 'xs',
  color: getDesignToken('text-default'),
  letterSpacing: 'sm',
});

export const MessageIcon = Icon.withConfig({
  color: getDesignToken('text-default'),
});
